import styled from 'styled-components';

export const AILoadingMessageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-right: 3rem;
`;